<template>
  <div class="evt-actions" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <vs-button class="evt-actions" color="success" @click="onMap" size="small">地図へ</vs-button>
  </div>
</template>

<script>
  export default {
    name: 'CellRendererActions',
    methods: {
      onMap() { // マップへ遷移
        this.$router.push({
          name: "enterprise-live-map",
          params: {plot_id: this.params.value}
        })
      },
    }
  }
</script>
